import { setLightLevel, setLightLevelClasses, useAmbientLightSensor, useDeviceLight } from "./utils";

var LightLevels = function LightLevels() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === undefined ? "light-level-" : _ref$prefix;

  var setClassNames = setLightLevel(setLightLevelClasses(prefix));

  if ("AmbientLightSensor" in window) {
    return useAmbientLightSensor(setClassNames);
  } else if ("ondevicelight" in window) {
    return useDeviceLight(setClassNames);
  } else {
    console.error("Sorry, your device does not support LightLevels");
  }
};

export default LightLevels;